<template>
  <div class="main" @click="infoClick">
    <div class="title">
      <img :src="require('@/assets/item-icon.png')" alt="">
      <!-- <a-tooltip placement="topLeft"> -->
        <template slot="title">
          <span>点击项目名称进行编辑</span>
        </template>
        <!-- <span @click.stop="titleClick">{{data.name}}</span> -->
        <span>{{data.name}}</span>
      <!-- </a-tooltip> -->
    </div>
    <div class="item item1">
      <dl>
        <dt>研究科室</dt>
        <dd>
          <div class="dd-list" v-for="item in JSON.parse(data.deptJson)" :key="item.id">{{ item.name }}</div>
        </dd>
      </dl>
      <dl>
        <dt>研究病种</dt>
        <dd>
          <div class="dd-list" v-for="item in JSON.parse(data.diseaseJson)" :key="item.id">{{ item.name }}</div>
        </dd>
      </dl>
    </div>
    <div class="item item2">
      <dl>
        <dt>负责人</dt>
        <dd>{{data.personName}}</dd>
      </dl>
      <dl>
        <dt>受试者人数</dt>
        <dd>{{data.patientCount || 0}}</dd>
      </dl>
      <dl>
        <dt>项目投入</dt>
        <dd>{{costNum}}万</dd>
      </dl>
    </div>
    <div class="item item3">
      <dl>
        <dt>建设周期</dt>
        <dd>{{data.rStartDate || data.startDate }} ~ {{data.rEndDate || '未知'}}</dd>
      </dl>
      <dl>
        <dt>项目状态</dt>
        <dd><a-tag :color="statusColor">{{statusText}}</a-tag></dd>
      </dl>
    </div>
  </div>
</template>
<script >
export default {
  name: 'ProjectCard',
  props:{
    data:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data(){
    return {

    }
  },
  computed:{
    statusColor(){
      let result = ''
      if(this.data.status =='0'){
        result='purple'
      }
      else if(this.data.status =='1'){
        result='cyan'
      }
      else if(this.data.status =='2'){
        result='green'
      }
      return result
    },
    statusText(){
      let result = '未知'
      if(this.data.status =='0'){
        result='创建中'
      }
      else if(this.data.status =='1'){
        result='待启动'
      }
      else if(this.data.status =='2'){
        result='已启动'
      }
      return result
    },
    costNum(){
      let result = this.data.cost || 0
      return (result/10000).toFixed(2)
    }
  },
  mounted(){
  },
  methods:{
    infoClick(){
      this.$emit('clickGo',this.data.id)
    },
    titleClick(e){
      this.$emit('titleClick',this.data.id)
    }
  }
}
</script>
<style scoped lang="less">
  .main{
    width: 320px;
    border-radius: 12px;
    padding: 15px;
    background-image: url(~@/assets/item-bg.png);
    background-size: 100% 100%;
    cursor: pointer;
    .title{
      display: flex;
      align-items: center;
      span{
        font-size: 18px;
        font-weight: 600;
        color: white;
        margin: -3px 0 0 15px;
      }
    }
    .item{
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      dl{
 
        margin-bottom: 0;
      }
      dt{
        font-size: 12px;
        font-weight: 400;
        color: rgba(255,255,255,0.7);
        white-space: nowrap;
      }
    }
    // .item1 dd,
    .item2 dd{
      color: white;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      margin: 5px 8px 0 0;
      border-radius: 8px;
    }
    .item1{
      dl{
        width: 50%;
      }
      dd {
        display: flex;
        justify-content: flex-start;
        gap: 10px;
        margin: 5px 0 0;
        .dd-list{
          display: inline-block;
          font-weight: 600;
          font-size: 12px;
          color: white;
          padding: 2px 5px;
          white-space: nowrap;
          border-radius: 8px;
          background: rgba(255,255,255,0.15);
        }
      }
    }
    .item2{
      justify-content: space-between;
      dd {
        font-weight: 600;
        font-size: 14px;
      }
    }
    .item3{
      justify-content: space-between;
      dd{
        margin: 5px 0px 0 0;
      }
      dl:first-of-type{
        dd{
          color: white;
          font-size: 16px;
          font-weight: bold;
        }
      }
      dl:last-of-type{
        text-align: center;
        dd{
          span{margin: 0;}
        }
      }
    }
  }
</style>